import { getField, updateField } from 'vuex-map-fields'
import { EnumGeolocationPermissionState } from '@/constants/EnumsRedeCredenciada'

const initialState = () => ({
  acreditacoesLegenda: [],
  activeNames: [],
  densidade: 0,
  equipeMedica: [],
  especialidades: [],
  guiasImpressos: [],
  horarios: [],
  loading: false,
  locations: [],
  planos: [],
  filtroPlanos: [],
  idPlano: null,
  prestador: {},
  printType: 'detail',
  redeCredenciada: null,
  serverError: false,
  showDetalhe: false,
  showEmpty: true,
  showGuiaImpresso: false,
  showPrint: false,
  showRedeVazia: false,
  totalRegistros: 0,
  geolocalizacao: {},
  permiteGeolocalizacao: false,
  apenasGuiaImpresso: false,
  solicitaGeolocalizacaoNoCarregamento: false,
  filtros: {
    order: ''
  }
})

const state = initialState

const getters = {
  getField,
  acreditacoesLegenda: state => state.acreditacoesLegenda,
  activeNames: state => state.activeNames,
  especialidades: state => state.especialidades,
  loading: state => state.loading,
  locations: state => state.locations,
  planos: state => state.planos,
  idPlano: state => state.idPlano,
  prestador: state => state.prestador,
  redeCredenciada: state => state.redeCredenciada,
  serverError: state => state.serverError,
  totalRegistros: state => state.totalRegistros,
  geolocalizacao: state => state.geolocalizacao,
  permiteGeolocalizacao: state => state.permiteGeolocalizacao,
  apenasGuiaImpresso: state => state.apenasGuiaImpresso,
  solicitaGeolocalizacaoNoCarregamento: state => state.solicitaGeolocalizacaoNoCarregamento,
  filtros: state => state.filtros,
  filtroPlanos: state => state.filtroPlanos
}

const actions = {
  setDensidade ({ commit }, densidade) {
    commit('SET_DENSIDADE', densidade)
  },
  setLoading ({ commit }, payload) {
    commit('SET_LOADING', payload)
  },
  setPrestador ({ commit }, payload) {
    commit('SET_PRESTADOR', payload)
  },
  setPrestadorEquipeMedica ({ commit }, equipeMedica) {
    commit('SET_PRESTADOR_EQUIPE_MEDICA', equipeMedica)
  },
  setPrestadorEspecialidades ({ commit }, especialidades) {
    commit('SET_PRESTADOR_ESPECIALIDADES', especialidades)
  },
  setPrestadorHorarios ({ commit }, horarios) {
    commit('SET_PRESTADOR_HORARIOS', horarios)
  },
  setPrestadorPlanos ({ commit }, planos) {
    commit('SET_PRESTADOR_PLANOS', planos)
  },
  setPrintType ({ commit }, printType) {
    commit('SET_PRINT_TYPE', printType)
  },
  setRedeCredenciada ({ commit }, payload) {
    commit('SET_REDE_CREDENCIADA', payload)
  },
  setServerError ({ commit }, payload) {
    commit('SET_SERVER_ERROR', payload)
  },
  setShowRedeVazia ({ commit }, showRedeVazia) {
    commit('SHOW_REDE_VAZIA', showRedeVazia)
  },
  setViewDetalhe ({ commit }, payload) {
    commit('SHOW_DETALHE', payload)
  },
  setViewGuiaImpresso ({ commit }, showGuiaImpresso) {
    commit('SHOW_GUIA_IMPRESSO', showGuiaImpresso)
  },
  setViewPrint ({ commit }, payload) {
    commit('SHOW_PRINT', payload)
  },
  setPermiteGeolocalizacao ({ commit }, payload) {
    commit('SET_PERMITE_GEOLOCALIZACAO', payload)
  },
  setApenasGuiaImpresso ({ commit }, payload) {
    commit('SET_APENAS_GUIA_IMPRESSO', payload)
  },
  setSolicitaGeolocalizacaoNoCarregamento ({ commit }, payload) {
    commit('SET_SOLICITA_GEOLOCALIZACAO_NO_CARREGAMENTO', payload)
  },
  setGeolocalizacao ({ commit }, payload) {
    commit('SET_GEOLOCALIZACAO', payload)
  },
  setFiltros ({ commit }, payload) {
    commit('SET_FILTROS', payload)
  },
  setFiltroPlanos ({ commit }, payload) {
    commit('SET_FILTRO_PLANOS', payload)
  }
}

const mutations = {
  updateField,
  SET_DENSIDADE (state, densidade) {
    state.densidade = densidade
  },
  SET_LOADING (state, payload) {
    state.loading = payload.loading
  },
  SET_PRESTADOR (state, payload) {
    state.prestador = payload
  },
  SET_PRESTADOR_EQUIPE_MEDICA (state, equipeMedica) {
    state.equipeMedica = equipeMedica
  },
  SET_PRESTADOR_ESPECIALIDADES (state, especialidades) {
    state.especialidades = especialidades
  },
  SET_PRESTADOR_HORARIOS (state, horarios) {
    state.horarios = horarios
  },
  SET_PRESTADOR_PLANOS (state, planos) {
    state.planos = planos
  },
  SET_PRINT_TYPE (state, printType) {
    state.printType = printType
  },
  SET_REDE_CREDENCIADA (state, payload) {
    state.idPlano = payload.idPlano
    state.redeCredenciada = payload.redeCredenciada
    state.locations = payload.locations
    state.totalRegistros = payload.totalRegistros
    state.acreditacoesLegenda = payload.acreditacoesLegenda
    state.activeNames = payload.activeNames
    state.showEmpty = false
    state.showGuiaImpresso = false
  },
  SET_SERVER_ERROR (state, payload) {
    state.serverError = payload.serverError
  },
  SHOW_DETALHE (state, payload) {
    state.showDetalhe = payload
  },
  SHOW_GUIA_IMPRESSO (state, showGuiaImpresso) {
    state.showGuiaImpresso = showGuiaImpresso
  },
  SHOW_PRINT (state, payload) {
    state.showPrint = payload
  },
  SHOW_REDE_VAZIA (state, showRedeVazia) {
    state.showRedeVazia = showRedeVazia
  },
  SET_PERMITE_GEOLOCALIZACAO (state, payload) {
    state.permiteGeolocalizacao = payload
  },
  SET_APENAS_GUIA_IMPRESSO (state, payload) {
    state.apenasGuiaImpresso = payload
  },
  SET_SOLICITA_GEOLOCALIZACAO_NO_CARREGAMENTO (state, payload) {
    state.solicitaGeolocalizacaoNoCarregamento = payload
  },
  SET_GEOLOCALIZACAO (state, payload) {
    state.geolocalizacao = { ...state.geolocalizacao, ...payload }
    if (payload.permissionState && payload.permissionState === EnumGeolocationPermissionState.DENIED) {
      state.permiteGeolocalizacao = false
    }
  },
  SET_FILTROS (state, payload) {
    state.filtros = { ...state.filtros, ...payload }
  },
  SET_FILTRO_PLANOS (state, payload) {
    state.filtroPlanos = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
